import { SET_LATEST_NEWS, SET_NEWS_DETAIL } from '../actions/newsActions'
import NewsModel from '../../models/NewsModel'

export interface NewsState {
  latestNews: NewsModel[]
  newsDetail: NewsModel[]
}

interface NewsAction {
  type: string
  latestNews?: NewsModel[]
  newsDetail?: NewsModel[]
}

const initialState: NewsState = {
  latestNews: [],
  newsDetail: [],
}

const newsReducer = (state: NewsState = initialState, action: NewsAction): NewsState => {
  switch (action.type) {
    case SET_LATEST_NEWS:
      return {
        ...state,
        latestNews: action.latestNews || [],
      }
    case SET_NEWS_DETAIL:
      return {
        ...state,
        newsDetail: action.newsDetail || [],
      }
    default:
      return state
  }
}

export default newsReducer 